import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import {
  addPercentageFormat,
  removePercentageFormat,
} from '@qtek/shared/utils';

@Directive({
  selector: 'input[qtPercentControl]',
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: PercentInputDirective,
      multi: true,
    },
  ],
})
export class PercentInputDirective implements ControlValueAccessor {
  private maxNumbersAfterDot = 3;
  value: string;

  constructor(
    private _elementRef: ElementRef<HTMLInputElement>,
    private _renderer: Renderer2
  ) {}

  @HostListener('input', ['$event'])
  onInput(event: any) {
    this.value = this.getValueFromEvent(event);

    this.onChange(removePercentageFormat(this.value));

    event.target.value = this.value;
  }

  @HostListener('blur', ['$event'])
  onBlur(event: any) {
    this.value = this.getValueFromEvent(event);

    this.onTouched(removePercentageFormat(this.value));

    event.target.value = this.value;
  }

  private getValueFromEvent(event: any) {
    const rawValue: string = event.target.value;
    const value: string = event.target.value.match(
      /([0-9]+([.][0-9]*)?|[.][0-9]+)/g
    )?.[0];

    if (!rawValue.trim()) {
      return '';
    } else if (value === undefined) {
      return '0';
    } else {
      const splitedVal = value.split('.');
      if (splitedVal[1]?.length > this.maxNumbersAfterDot) {
        splitedVal[1] = splitedVal[1].slice(0, this.maxNumbersAfterDot);
      }

      return splitedVal.join('.');
    }
  }

  onChange = (value: string) => {
    return;
  };
  onTouched = (value: string) => {
    return;
  };

  writeValue(rawPercents: string): void {
    this.value = addPercentageFormat(rawPercents);
    this._renderer.setAttribute(
      this._elementRef.nativeElement,
      'value',
      this.value
    );
  }

  registerOnChange(fn: (_: any) => void): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
